<template>
  <div :id="localId"></div>
</template>

<script>
import * as d3 from 'd3'
import mx_Core from './includes/mixins/zMixins'          // Global & Local Mixins

export default {
  name: "j-chart-bar-delta",
  mixins: [mx_Core],
  props: {
    id: String,
    ChartType: String,
    
    // Chart Data
    Canvas: { type: Object, default: () => ({}) },
    Title: { type: Object, default: () => ({}) },
    Note: { type: Object, default: () => ({}) },

    // Database
    Delta: { type: Object, default: () => ({}) },
    DataItems: { type: Array, default: () => ([]) },

    values: {
      type: Object,
      default: () => ({
        milestone: [],
        note: '',
      })
    }
  },
  created() {
    this.localId = `${this.id || 'j-chart-bar-delta'}__${this.safeId('')}`
  },
  mounted() {
    this.register(this.draw)
  },

  methods: {
    draw() {
      // Check all the necessary values are available
      if (!this.ready2draw) return

      this.clear()
      this.set_LocalValues()
      this.drawCanvas()
      this.drawChart()
      this.drawTitles()
      this.drawNotes()

      // 'complete' must be executed to finish the parent process.
      // It sends 'this.localId' & XmlString for some case to make 
      // displaying image easy.
      this.complete()
    },
  }
}
</script>